import popupService from '@/services/popupService'

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$popup', {
      get() {
        return popupService
      }
    })
  }
}
